<div
  [ngClass]="{ border: !hasShadow, box: hasShadow }"
  class="content-expander guts-m-v-1"
>
  <div class="l_flexbar l_flex-justify full-width guts-p-full-1">
    <span class="l_flex-grow l_flex l_flex-wrap">
      <ng-content select="[header]"></ng-content>
    </span>

    <span class="vertical-divider guts-m-h-2"></span>

    <button
      type="button"
      (click)="toggleDetails()"
      attr.aria-expanded="{{ isOpen }}"
      data-dgat="profile-experience-header-cc5"
      class="color-ebony-a61"
    >
      <df-icon
        class="guts-m-r-1"
        size="medium"
        [icon]="isOpen ? 'chevron-up' : 'chevron-down'"
      ></df-icon>
    </button>
  </div>

  <div
    id="js-animate-toggle-permission-panel-{{ uid }}"
    attr.aria-labelledby="js-animate-toggle-permission-trigger-{{ uid }}"
    attr.aria-live="polite"
    role="region"
    class="rel oh"
  >
    <div *ngIf="isOpen" [@dfCollapseExpand]>
      <ng-content select="[body]"></ng-content>
    </div>
  </div>
</div>
